<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle">It’s Lonely in the Modern World</h1>
<p class="center">The Essential Guide to Form, Function, and Ennui from the Creators of UnhappyHipsters.com</p>
<p class="white1"></p>
<h3 class="author">Written by Molly Jane Quinn</h3>
<h3 class="author">Illustrated by Jenna Talbott</h3>
<p class="white1"></p>
<p class="publogo"><img alt="publisher logo" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003titlepage.vue?2743b3c8